var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print"},[(_vm.id)?_c('pot-1-print-sheet',{attrs:{"id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }